const HOST_NAME = window.location.hostname

export const Environment = Object.freeze({
    Dev: 'dev',
    Stage: 'stg',
    Prod: 'prod'
})

export class environmentService {

    getEnvironment() {
        if (HOST_NAME.includes('dev') || HOST_NAME.includes('e1demo') ||  HOST_NAME.includes('localhost')) {
            return Environment.Dev;
        } else if (HOST_NAME.includes('stg') || HOST_NAME.includes('oneap-qa') || HOST_NAME.includes('e2') || HOST_NAME.includes('demo') || HOST_NAME.includes('test')) {
            return Environment.Stage;
        } else {
            return Environment.Prod;
        }
    }
}